<nz-drawer
  [nzVisible]="isDrawerVisible"
  [nzMask]="true"
  [nzMaskClosable]="true"
  nzPlacement="right"
  [nzClosable]="false"
  [nzTitle]="'page.qualifications.drawer.title' | translate"
  (nzOnClose)="closeDrawer.emit()"
>
  <ng-container *nzDrawerContent>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'account.status' | translate }}
      </div>
      <wilson-qualification-v2-status-filter
        (modelChange)="onStatusChange($event)"
      ></wilson-qualification-v2-status-filter>
    </div>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'page.qualifications.category' | translate }}
      </div>
      <wilson-qualification-v2-category-filter
        (modelChange)="onCategoryChange($event)"
      ></wilson-qualification-v2-category-filter>
    </div>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'service.shift_orgunit' | translate }}
      </div>
      <wilson-organizational-unit-filter
        class="mb-2"
        (modelChange)="onOrgUnitChange($event)"
      ></wilson-organizational-unit-filter>
    </div>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'page.shift.filter_labels' | translate }}
      </div>
      <wilson-user-labels-filter
        class="mb-2"
        (modelChange)="onUserLabelsChange($event)"
      ></wilson-user-labels-filter>
    </div>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'general.users' | translate }}
      </div>
      <wilson-users-list-filter
        class="mb-2"
        (modelChange)="onUserIdsChange($event)"
      ></wilson-users-list-filter>
    </div>
  </ng-container>
</nz-drawer>
